@if (externalReviewsNormalized()?.data?.ReviewSummary) {
  <h2 class="text-2xl font-bold">Helhetsintryck</h2>
  <div class="text-base text-grey-3 mb-5">Baserat på {{ externalReviewsNormalized().data.ReviewSummary.reviewsTotal }}
    textrecensioner*
  </div>

  @if (prosAndConsGrouped()) {
    <div class="flex flex-col gap-8">
      @if (externalReviewsNormalized().data.ReviewSummary.text) {
        <div [innerHTML]="externalReviewsNormalized().data.ReviewSummary.text"
             class="text-base text-grey-0"></div>
      }

      @if (prosAndConsGrouped().many && prosAndConsGrouped().many.length > 0) {
        <ng-container
          *ngTemplateOutlet="itemTemplate; context: {items: prosAndConsGrouped().many, header: 'Många tycker', icon: 'users_many'}"
        ></ng-container>
      }

      @if (prosAndConsGrouped().some && prosAndConsGrouped().some.length > 0) {
        <ng-container
          *ngTemplateOutlet="itemTemplate; context: {items: prosAndConsGrouped().some, header: 'Några tycker', icon: 'users_some'}"
        ></ng-container>
      }

      @if (prosAndConsGrouped().single && prosAndConsGrouped().single.length > 0) {
        <ng-container
          *ngTemplateOutlet="itemTemplate; context: {items: prosAndConsGrouped().single, header: 'Enstaka tycker', icon: 'users_single'}"
        ></ng-container>
      }

      @if (externalReviewsNormalized().data.ReviewSummary.suitableFor) {
        <div class="flex flex-col gap-0">
          <div class="font-medium">Särskilt lämplig för</div>
          <div [innerHTML]="externalReviewsNormalized().data.ReviewSummary.suitableFor" class="text-base"></div>
        </div>
      }

      @if (sourcesString() !== '') {
        <div [innerHTML]="sourcesString()" class="text-sm text-grey-1"></div>
      }
    </div>
  }
}

<ng-template #itemTemplate let-header="header" let-icon="icon" let-items="items">
  <div class="flex flex-col gap-1">
    <div class="flex flex-row justify-start gap-2 items-center">
      <app-ui-icon [name]="icon" color="var(--grey-0)"
                size="md"></app-ui-icon>
      <div class="font-medium">{{ header }}</div>
    </div>

    @for (item of items; track item.text) {
      <div class="flex flex-row justify-start gap-2 items-center">
        <div class="w-6 flex justify-center items-center">
          @if (item.type === ProsAndConsTypeEnum.PROS) {
            <app-ui-icon
              color="var(--success-2)"
              name="heart_filled"
              size="sm"></app-ui-icon>
          }
          @if (item.type === ProsAndConsTypeEnum.CONS) {
            <app-ui-icon
              color="var(--error-1)"
              name="close"
              size="sm"></app-ui-icon>
          }
        </div>
        <div>{{ item.text }}</div>
      </div>
    }

  </div>
</ng-template>
